import * as Sentry from '@sentry/react'

import { cx } from 'class-variance-authority'
import { BugIcon, Cog, LogOut, Mail, TowerControl } from 'lucide-react'
import { useCallback, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import r from 'routes'

import SalesDialog from '@/components/sales-dialog'
import { Button } from '@/components/ui/button'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card'
import { HoverCardItem, HoverCardSeparator } from '@/components/ui/hover-card-menu'
import { useAPI } from '@/hooks/useAPI'
import { useAuthSelector } from '@/store'
import { signOut } from '@/thunks/authentications/sign-out'

const AccountHover = () => {
  const { isRoot } = useAuthSelector()
  const navigate = useNavigate()
  const location = useLocation()
  const [showSalesModal, setShowSalesModal] = useState(false)

  const handleReportIssue = useCallback(async () => {
    const feedback = Sentry.getFeedback()
    const form = await feedback?.createForm()
    if (!form) return

    form.appendToDom()
    form.open()
  }, [])

  const [logout] = useAPI(signOut)
  const handleSignOut = useCallback(async () => {
    await logout({})
    navigate(r.root)
  }, [logout, navigate])

  return (
    <HoverCard openDelay={0} closeDelay={0}>
      <HoverCardTrigger asChild>
        <Button
          size="icon"
          variant="outline"
          className="group text-muted-foreground hover:text-foreground data-[state=open]:text-foreground !cursor-pointer relative"
          onClick={() => navigate(r.settings.root)}
          data-testid="settings-button"
        >
          <Cog size={4} className="transition-transform group-hover:rotate-45 group-data-[state=open]:rotate-45" />
        </Button>
      </HoverCardTrigger>
      <HoverCardContent className="p-1 -mt-1 w-56" align="end">
        <HoverCardItem
          className={cx(location.pathname.startsWith(r.settings.root) && 'bg-accent')}
          onClick={() => navigate(r.settings.root)}
          data-testid="account-settings-button"
        >
          <Cog size={16} className="mr-2" />
          Account Settings
        </HoverCardItem>
        {/* <HoverCardItem onClick={() => navigate(r.resources.root)}>
          <BookText size={16} className="mr-2" />
          Resources
        </HoverCardItem> */}

        {/* <HoverCardItem onClick={() => navigate(r.support.root)}>
          <LifeBuoy size={16} className="mr-2" />
          Support Center
        </HoverCardItem>
        <HoverCardItem>
          <MessageCircleQuestion size={16} className="mr-2" />
          Live Chat
        </HoverCardItem>
        <HoverCardItem onClick={() => window.open('https://trust.journeyid.com/', '_blank')}>
          <ShieldCheck size={16} className="mr-2" />
          Trust Center
        </HoverCardItem> */}
        <HoverCardItem onClick={() => setShowSalesModal(true)} data-testid="account-contact-sales-button">
          <Mail size={16} className="mr-2" />
          Contact sales
        </HoverCardItem>

        <HoverCardItem onClick={handleReportIssue} data-testid="account-report-issue-button">
          <BugIcon size={16} className="mr-2" />
          Report an issue
        </HoverCardItem>

        <HoverCardItem
          onClick={() => window.open('https://journeyid.statuspage.io/', '_blank')}
          data-testid="account-system-status-button"
        >
          <div className="inline-block w-3 h-3 ml-0.5 mr-2.5 bg-green-500 rounded-full cursor-pointer" />
          System status
        </HoverCardItem>

        <SalesDialog open={showSalesModal} onOpenChange={setShowSalesModal} />

        <HoverCardSeparator />

        {isRoot && (
          <>
            <HoverCardItem onClick={() => navigate(r.watchTower.root)}>
              <TowerControl size={16} className="mr-2" />
              Watch Tower
            </HoverCardItem>
            <HoverCardSeparator />
          </>
        )}

        <HoverCardItem onClick={handleSignOut} data-testid="account-sign-out-button">
          <LogOut size={16} className="mr-2" />
          Sign out
        </HoverCardItem>
      </HoverCardContent>
    </HoverCard>
  )
}

export default AccountHover
